import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion'; // Import framer-motion pour les animations
import '../Style/Recettes.css';

const recettesData = [
  {
    id: 1,
    titre: 'Gâteau au Chocolat',
    ingredients: [
      '200 g de chocolat noir',
      '150 g de beurre',
      '150 g de sucre',
      '4 œufs',
      '80 g de farine'
    ],
    instructions: [
      'Préchauffez le four à 180°C.',
      'Faites fondre le chocolat et le beurre au bain-marie.',
      'Ajoutez le sucre et mélangez bien.',
      'Incorporez les œufs un à un, puis ajoutez la farine.',
      'Versez dans un moule et enfournez pendant 25 minutes.'
    ]
  },
  {
    id: 2,
    titre: 'Cookies Moelleux',
    ingredients: [
      '250 g de farine',
      '125 g de beurre',
      '100 g de sucre roux',
      '1 œuf',
      '1 cuillère à café de levure',
      '100 g de pépites de chocolat'
    ],
    instructions: [
      'Préchauffez le four à 180°C.',
      'Mélangez le beurre ramolli et le sucre.',
      'Ajoutez l’œuf, puis la farine et la levure.',
      'Incorporez les pépites de chocolat.',
      'Formez des petites boules de pâte et disposez-les sur une plaque.',
      'Enfournez pendant 10 à 12 minutes.'
    ]
  },
  {
    id: 3,
    titre: 'Mousse au Chocolat',
    ingredients: [
      '200 g de chocolat noir',
      '4 œufs',
      '1 pincée de sel'
    ],
    instructions: [
      'Faites fondre le chocolat au bain-marie.',
      'Séparez les blancs des jaunes d’œufs.',
      'Incorporez les jaunes au chocolat fondu.',
      'Battez les blancs en neige avec le sel.',
      'Incorporez délicatement les blancs au mélange chocolat.',
      'Laissez reposer au frais pendant au moins 3 heures.'
    ]
  },
  {
    id: 4,
    titre: 'Tarte au Citron Meringuée',
    ingredients: [
      '1 pâte sablée',
      '3 citrons',
      '150 g de sucre',
      '3 œufs',
      '150 g de sucre glace'
    ],
    instructions: [
      'Préchauffez le four à 180°C.',
      'Foncez un moule avec la pâte sablée et faites cuire à blanc pendant 15 minutes.',
      'Mélangez le jus des citrons, le sucre et les œufs.',
      'Versez le mélange sur la pâte et faites cuire pendant 20 minutes.',
      'Montez les blancs d’œufs en neige avec le sucre glace.',
      'Disposez la meringue sur la tarte et passez sous le gril pour la colorer.'
    ]
  }
];

const Recettes = () => {
  const [selectedRecette, setSelectedRecette] = useState(null);

  const handleCloseModal = () => setSelectedRecette(null);

  return (
    <div className="recettes-container">
      <h1>Nos Recettes de Pâtisserie</h1>
      {recettesData.map(({ id, titre }) => (
        <motion.div
          key={id}
          className="recette-card"
          onClick={() => setSelectedRecette(id)}
          whileHover={{ scale: 1.1 }} // Effet de zoom au survol
          whileTap={{ scale: 0.95 }} // Effet de réduction à l'appui
          initial={{ opacity: 0, y: 50 }} // Apparition fluide
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
        >
          <h2>{titre}</h2>
        </motion.div>
      ))}

      <AnimatePresence>
        {selectedRecette && (
          <div className="modal-overlay" onClick={handleCloseModal}>
            <motion.div
              className="modal-content"
              onClick={(e) => e.stopPropagation()}
              initial={{ scale: 0.5, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.5, opacity: 0 }}
              transition={{ duration: 0.3 }}
            >
              <button onClick={handleCloseModal} className="close-button">X</button>
              <h2>{recettesData[selectedRecette - 1].titre}</h2>
              <h3>Ingrédients :</h3>
              <ul>
                {recettesData[selectedRecette - 1].ingredients.map((ingredient, index) => (
                  <li key={index}>{ingredient}</li>
                ))}
              </ul>
              <h3>Instructions :</h3>
              <ol>
                {recettesData[selectedRecette - 1].instructions.map((instruction, index) => (
                  <li key={index}>{instruction}</li>
                ))}
              </ol>
            </motion.div>
          </div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Recettes;
